import { Stack } from "@mui/material";
import { useMemo } from "react";
import ActionButton from "../../../components/common/table/ActionButton";
import { ActionModule } from "../../../types/actionModule/actionModule";

interface ActionModuleIconListProps {
    actionModules: ActionModule[];
}

export default function ActionModuleIconList(props: ActionModuleIconListProps) {
    const sortedActionModules = useMemo(
        () => props.actionModules.sort((a, b) => a.name.localeCompare(b.name)),
        [props.actionModules]
    );

    return <Stack direction="row" overflow="hidden">
        {sortedActionModules.map((a) => <ActionButton
            key={a.id}
            actionName={a.name}
            iconName={a.iconName}
            colorHex={a.colorHex}
            iconUrl={a.iconUrl}
            isEditMode={false}
            handleActionButtonDelete={undefined} />)}
    </Stack>
}